import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'

import FlowManager from 'components/FlowManager'
import CLPFlowRoutes from './routes'
import { STEP_COUNT_TOTAL, BOT_STEP_COUNT } from '../constants'
import { getCustomerSegment } from 'modules/billing/selectors'

const STEP_TOTAL = STEP_COUNT_TOTAL - BOT_STEP_COUNT

const mapStateToProps = (state) => {
  return {
    segment: getCustomerSegment(state)
  }
}

class OnboardingCLPFlow extends PureComponent {
  render() {
    const { match, history, segment } = this.props

    return (
      <Fragment>
        <FlowManager steps={CLPFlowRoutes} stepTotal={STEP_TOTAL} stepOffset={STEP_TOTAL} baseUrl={match.url} history={history} segment={segment} name='Playbook Onboarding'/>
      </Fragment>
    )
  }
}

export default connect(mapStateToProps, null)(OnboardingCLPFlow)



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/OnboardingCLPFlow/index.js